import { ALL, RoleType, UserMapDataType } from '../../types/analyticTypes';

/**
 * Returns the email options available for a given role: [ALL, ...matching emails].
 * Pure - derived solely from the API's email->roles map. `RoleType.all` returns every email.
 */
export const getUsersForRole = (userMap: UserMapDataType, role: RoleType): string[] => [
  ALL,
  ...Object.entries(userMap)
    .filter(([, roles]) => role === RoleType.all || roles.includes(role))
    .map(([user]) => user),
];

/**
 * True when all provided emails are valid choices for the given role.
 * `ALL` ("All users") is always valid, otherwise the email must exist in the role's options.
 */
export const isEmailValidForRole = (
  userMap: UserMapDataType,
  role: RoleType,
  emails: string[]
): boolean => {
  const validUsers = getUsersForRole(userMap, role);

  return emails.every((email) => email === ALL || validUsers.includes(email));
};
